import React from 'react';
import WidgetBox from '../WidgetBox';
import CallItem from '../../../Models/OfficeOnboarding/CallItem.model';
import { Button, CircularProgress, Grid, Paper, Stack, TextField, Tooltip, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../store/store';
import { clearOnboarderCallList, generateOnboarderCallList, skipOnboarderCallList } from '../../../store/adminOnboarding.slice';
import { RootState } from '../../../reducers';

const CurrentCallList = () => {
    const { selectedOnboarder, isGeneratingCallList } = useSelector((state: RootState) => state.adminOnboardingSlice);
    const dispatch = useAppDispatch();
    let callRows = undefined;
    if (selectedOnboarder.CallList) {
        callRows = selectedOnboarder.CallList.map((item: CallItem) => (
            <Grid margin={2}>
                <Paper elevation={2}>
                    <Grid container p={2} spacing={2} alignItems="flex-start" justifyContent="space-evenly" direction="column">
                        <Grid size={12}>
                            <TextField
                                variant="outlined"
                                label="First Name"
                                disabled
                                value={item.FirstName}
                                inputProps={{
                                    style: {
                                        textAlign: 'center',
                                        padding: '5px',
                                        color: 'black',
                                    },
                                }}
                            />
                        </Grid>
                        <Grid size={12}>
                            <TextField
                                variant="outlined"
                                label="Last Name"
                                disabled
                                value={item.LastName}
                                inputProps={{
                                    style: {
                                        textAlign: 'center',
                                        padding: '5px',
                                        color: 'black',
                                    },
                                }}
                            />
                        </Grid>
                        <Grid size={12}>
                            <TextField
                                variant="outlined"
                                label="Population"
                                disabled
                                value={item.PopulationName}
                                inputProps={{
                                    style: {
                                        textAlign: 'center',
                                        padding: '5px',
                                        color: 'black',
                                    },
                                }}
                            />
                        </Grid>
                        <Grid size={12}>
                            <TextField
                                variant="outlined"
                                label="Zip Code"
                                disabled
                                value={item.Zip}
                                inputProps={{
                                    style: {
                                        textAlign: 'center',
                                        minHeight: '15px',
                                        padding: '5px',
                                        color: 'black',
                                    },
                                }}
                            />
                        </Grid>
                        <Grid size={12}>
                            <TextField
                                variant="outlined"
                                label="Times Assigned"
                                disabled
                                value={item.TimesAssigned}
                                inputProps={{
                                    style: {
                                        textAlign: 'center',
                                        minHeight: '15px',
                                        padding: '5px',
                                        color: 'black',
                                    },
                                }}
                            />
                        </Grid>
                        <Grid size={12}>
                            <TextField
                                variant="outlined"
                                label="Times Assigned Today"
                                disabled
                                value={item.TimesAssignedToday}
                                inputProps={{
                                    style: {
                                        textAlign: 'center',
                                        minHeight: '15px',
                                        padding: '5px',
                                        color: 'black',
                                    },
                                }}
                            />
                        </Grid>
                    </Grid>
                </Paper>
            </Grid>
        ));
    }

    const clearCallListHandler = () => {
        const assignedOnboarderId = selectedOnboarder.CallList[0]?.AssignedOnboarderId;
        dispatch(clearOnboarderCallList(assignedOnboarderId));
    };

    const skipCallListHandler = () => {
        const assignedOnboarderId = selectedOnboarder.CallList[0]?.AssignedOnboarderId;
        dispatch(skipOnboarderCallList(assignedOnboarderId));
    };

    const generateCallListHandler = () => {
        const assignedOnboarderId = selectedOnboarder.UserId;
        dispatch(generateOnboarderCallList(assignedOnboarderId));
    };

    return (
        <WidgetBox>
            <Stack direction="row" spacing={2} justifyContent="space-between" alignItems={'center'} my={5} px={5}>
                <Stack direction={'row'} spacing={2}>
                    <Typography variant="h6">{selectedOnboarder.Username} Current Call List:</Typography>
                    <Typography variant="h6" fontWeight={'bold'}>
                        {callRows.length} Left
                    </Typography>
                </Stack>
                <Stack direction={'row'} spacing={4}>
                    <Tooltip title={<Typography>Creates a new call list for the provider.</Typography>}>
                        <Button
                            disabled={selectedOnboarder.CallList.length > 0 || isGeneratingCallList}
                            variant="contained"
                            color="success"
                            onClick={generateCallListHandler}
                            sx={{ mb: 2 }}
                            startIcon={isGeneratingCallList ? <CircularProgress size={16} color="inherit" /> : null}
                        >
                            Generate Call List
                        </Button>
                    </Tooltip>
                    <Tooltip
                        title={
                            <Typography>
                                Cleared members will be added <b>FIRST</b> on new call list generation.
                            </Typography>
                        }
                    >
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={clearCallListHandler}
                            disabled={selectedOnboarder.CallList.length === 0}
                            sx={{ mb: 2 }}
                        >
                            Clear Call List
                        </Button>
                    </Tooltip>
                    <Tooltip
                        title={
                            <Typography>
                                Skipped members will be added <b>LAST</b> on new call list generation.
                            </Typography>
                        }
                    >
                        <Button
                            variant="contained"
                            color="error"
                            onClick={skipCallListHandler}
                            disabled={selectedOnboarder.CallList.length === 0}
                            sx={{ mb: 2 }}
                        >
                            Skip Call List
                        </Button>
                    </Tooltip>
                </Stack>
            </Stack>
            <Grid direction="row" alignItems="center" justifyContent="center" container spacing={1}>
                {React.Children.toArray(callRows)}
            </Grid>
        </WidgetBox>
    );
};

export default CurrentCallList;
